import { render, staticRenderFns } from "./aua.vue?vue&type=template&id=3798aac0&scoped=true"
import script from "./aua.vue?vue&type=script&lang=js"
export * from "./aua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798aac0",
  null
  
)

export default component.exports